/**
 * Tracks renderer event IDs within one simulation instance. A replacement run
 * gets a fresh ID namespace, even when its first events reuse low IDs.
 */
export class VisualEventRunGate<TRun extends object> {
  private run: TRun | null = null;
  private seenIds = new Set<number>();

  begin(run: TRun): boolean {
    if (this.run === run) return false;
    this.run = run;
    this.seenIds.clear();
    return true;
  }

  accept(id: number): boolean {
    if (this.seenIds.has(id)) return false;
    this.seenIds.add(id);
    return true;
  }

  retain(ids: readonly number[]): void {
    const retained = new Set(ids);
    this.seenIds = new Set([...this.seenIds].filter((id) => retained.has(id)));
  }

  get size(): number {
    return this.seenIds.size;
  }
}
